import useDropdownOptions from "~/hooks/useDropdownOptions";

const useDocumentStatuses = () => useDropdownOptions("/documents/statuses");

export default useDocumentStatuses;
